module.exports = __webpack_public_path__ + "img/default.870b0aef.jpg";